export { PageLoginComponent as PageLogin } from './component';



// WEBPACK FOOTER //
// ./src/pages/login/index.tsx